import { render, staticRenderFns } from "./TableFour.vue?vue&type=template&id=5356fa4c&scoped=true&"
import script from "./TableFour.vue?vue&type=script&lang=js&"
export * from "./TableFour.vue?vue&type=script&lang=js&"
import style0 from "./TableFour.vue?vue&type=style&index=0&id=5356fa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356fa4c",
  null
  
)

export default component.exports